import { FiveDayLadderSelection } from './../survival-horizon/five-day-ladder/five-day-ladder-selection';
import { DashboardMetricSet } from './dashboard-metric';
import { DashboardGraphicalConfig } from './dashboard-graphical';
import { DashboardViewSelection } from './../dashboard/dashboard-view-selection';
import { UserProfile, ProjectionMonitoringData, SystemMessage, ApplicationConfiguration } from '@liquitics/transaction';
import { Message } from 'primeng/api';
import { SHLadderSelection } from './../survival-horizon/s-h-ladder/s-h-ladder-selection';
import { BucketingStrategy } from './../bucket/bucketing-strategy';
import { MetricSelection } from './../metrics/metric-selection';
import { ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class DashboardEventService {

    toggleSideBarSliderSubject = new ReplaySubject<boolean>(1);

    ladderViewModeSubject = new ReplaySubject<string>(1);
    ladderBucketingStrategySubject = new ReplaySubject<BucketingStrategy>(1);
    ladderRowSelectionSubject = new ReplaySubject<SHLadderSelection>(1);
    compareLadderRowSelectionSubject = new ReplaySubject<SHLadderSelection>(1);
    metricSelectionSubject = new ReplaySubject<MetricSelection>(1);
    projectionMonitoringDataSelectionSubject = new ReplaySubject<ProjectionMonitoringData>(1);
    survivalHorizonModeSubject = new ReplaySubject<string>(1);
    emergencyMessageSubject = new ReplaySubject<Message>(1);
    systemMessageSubject = new ReplaySubject<SystemMessage[]>(1);
    alertSelectionSubject = new ReplaySubject<string>(1);
    restartSubject = new ReplaySubject<Date>(1);
    timeShiftSubject = new ReplaySubject<moment.Moment>(1);
    explainTimeShiftSubject = new ReplaySubject<moment.Moment>(1);
    profileSubject = new ReplaySubject<UserProfile>(1);
    applicationConfigurationSubject = new ReplaySubject<ApplicationConfiguration>(1);

    currencySelectionSubject = new ReplaySubject<string>(1);
    viewSelectionSubject = new ReplaySubject<DashboardViewSelection<unknown>>(1);
    viewModeSelectionSubject = new ReplaySubject<string>(1);
    dashboardMetricCategorySubject = new ReplaySubject<DashboardMetricSet>(1);
    dashboardGraphicalConfigSubject = new ReplaySubject<DashboardGraphicalConfig>(1);

    fiveDayLadderRowSelectionSubject = new ReplaySubject<FiveDayLadderSelection>(1);
    restartLive() {
        const date = new Date();
        date.setFullYear(2099);
        this.restartSubject.next(date);
    }
}

